import React from 'react';

const MainPage = () => {
    return (
        <div>
            <h1>Main Page</h1>
            <p>Welcome to the main content of the website!</p>
        </div>
    );
};

export default MainPage;
